<template>
    <div id="contactTwo">
        <div id="contactImg">
            <img src="../../assets/imgs/contact/logo.png">
            <img src="../../assets/imgs/code.jpg">
        </div>
        <!-- 电话 -->
        <div id="contactTel">
            <div>
                <div class="telWapper">
                    <p>客服热线</p>
                    <div>022-58951598</div>
                    <span>工作日早8:30 - 晚5:30</span>
                </div>
            </div>
            <div>
                <div class="telWapper">
                    <p>商务合作</p>
                    <div>18622595935</div>
                    <span>工作日早8:30 - 晚5:30</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Screen4',
}
</script>

<style scoped>
    #contactTwo{
        margin-bottom: 25px;
    }
    #contactImg{
        width: 1120px;
        margin: 0 auto;
        height: 140px;
        display: flex;                      
        align-items:Center;
        background: #e7e7e7;
        position: relative;
        margin-bottom: 20px;
    }
    #contactImg>img{
        position: absolute;
    }
    #contactImg>:first-child{
        width: 200px;
        left: 85px;
    }
    #contactImg>:last-child{
        width: 130px;
        right:180px;
    }
    #contactTel{
        width: 1120px;
        margin: 0 auto;
        overflow: hidden;
    }
    #contactTel>div{
        width: calc((100% - 40px) / 2) ;
        border: 1px solid #eeedf2;
        background: #f5f7fa;        
    }
    .telWapper{
        padding: 20px 0 15px 30px;
    }
    #contactTel>div:first-child{
        margin-right: 35px;
        float: left;
    }
    #contactTel>div:first-child>div{
        background: url(../../assets/imgs/contact/tel1.png) no-repeat;
        background-position: 430px 20px;
    }
    #contactTel>div:last-child{
        float: right;
    }
    #contactTel>div:last-child>div{
        background: url(../../assets/imgs/contact/tel2.png) no-repeat;
        background-position: 430px 20px;
    }
    .telWapper>p{
        font-size: 16px;
    }
    .telWapper>div{
        font-size: 20px;
        color: #ff8418;
        margin: 7px 0 13px 0;
    }
    .telWapper>span{
        font-size: 12px;
        color: #606163;
    }
</style>
